import { useEffect, useRef } from 'react';

import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';
import { Products } from '@/shared/types/Billing';

export const usePricingExperimentExposure = (
  products?: Products,
  ready = true,
  sendExposure = MixpanelEvents.pricingPageShown,
  openedAutomatically = false,
) => {
  const sent = useRef(false);

  useEffect(() => {
    if (sent.current || !ready || !products) return;

    const experiment = products.pricing_experiment;
    const properties = {
      pricing_opened_automatically: openedAutomatically,
      // Grid C now only describes existing subscribers, not an experiment arm a visitor was exposed to.
      ...(experiment?.eligible && experiment.variant && experiment.grid !== 'C'
        ? {
            pricing_experiment_key: experiment.key,
            pricing_experiment_variant: experiment.variant,
          }
        : {}),
    };

    sendExposure(properties);
    sent.current = true;
  }, [openedAutomatically, products, ready, sendExposure]);
};
